import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {reverse} from 'named-urls';
import React from 'react';
import routes from '../../../../routes';


const Wrapper = ({title, loading, titleControls, request, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading} controls={titleControls}/>
      <Notice
        display={request && request.archived}
        message={[
          'This request has been archived and is therefore no longer available.',
          request?.deleted_at ? 'You won\'t be able to modify it unless it is restored.' : 'A relation was archived therefore you can not restore it directly'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['request']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Orders', link: routes.orders.index},
  {title: 'Review Requests', link: reverse(routes.reviewRequests.index)}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: reverse(routes.archive.index)}
];

export default Wrapper;
